import Button from "../../../../../Components/Common/Button/Button";
import { NewProjectFormValues, ReviewSection } from "../types";

interface Step6ReviewProps {
  values: NewProjectFormValues;
  reviewData: ReviewSection[];
  submitError: string;
  submitLoading: boolean;
  onBack: () => void;
  onSubmit: () => void;
}

export default function Step6Review({
  values,
  reviewData,
  submitError,
  submitLoading,
  onBack,
  onSubmit,
}: Step6ReviewProps) {
  return (
    <div className="stepPanel active">
      <div className="card">
        <div className="cardTitle">Review &amp; Submit</div>
        <p className="reviewIntroText">
          Please review the information below before submitting.
        </p>
        {reviewData.map((section, idx) => (
          <div key={idx} className="reviewSection">
            <div className="reviewSectionTitle">{section.title}</div>
            <div className="reviewGrid">
              {section.items.map((item, itemIdx) => (
                <div key={itemIdx} className="reviewItem">
                  <div className="riLabel">{item.label}</div>
                  <div
                    className={`riValue ${item.value === "-" ? "empty" : ""}`}
                    style={
                      item.multiline ? { whiteSpace: "pre-wrap" } : undefined
                    }
                  >
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {values.requirements.precon === "yes" && (
          <div className="preconNotice">
            <strong>Pre-Construction Review Required</strong>
            Upon submission, the general contractor ({values.gcName || "-"})
            will receive notification with the {values.projectType || ""}{" "}
            pre-construction checklist. Target report date:{" "}
            {values.preconDate || "-"}.
          </div>
        )}
      </div>
      {submitError && <p className="submitError">{submitError}</p>}
      <div className="btnRow">
        <Button className="btn btnSecondary" onClick={onBack}>
          ← Back
        </Button>
        <Button
          className="btn btnSuccess"
          disabled={submitLoading}
          onClick={onSubmit}
        >
          {submitLoading ? (
            <>
              <span className="btn-spinner" /> Creating
            </>
          ) : (
            "Create Project →"
          )}
        </Button>
      </div>
    </div>
  );
}
